import React, { useEffect, useState } from 'react'
import 'leaflet/dist/leaflet.css'

import { useSelector } from 'react-redux'
import { getEventLocations } from '../../../store/data/data.selectors'
import LocationMap from '../../../shared/components/Location/LocationMap'
import { LatLng } from 'leaflet'

interface IProps {
  positions: LatLng[]
  label?: string[]
  height?: number
  mapZoom?: number
}

const EventMap: React.FC<IProps> = (props) => {
  const eventLocations = useSelector(getEventLocations)

  const [positions, setPositions] = useState<LatLng[]>([])
  const [label, setLabel] = useState<string[]>([])

  useEffect(() => {
    const newPos: LatLng[] = []
    const newLabel: string[] = []
    eventLocations?.results.map(location => {
      const stringCoords = location.coordinates?.split(',')
      const coordinates: number[] = []
      stringCoords && stringCoords[0] && coordinates.push(parseInt(stringCoords[0], 10))
      stringCoords && stringCoords[1] && coordinates.push(parseInt(stringCoords[1], 10))

      location.coordinates && newPos.push(new LatLng(coordinates[0], coordinates[1]))
      location.coordinates && newLabel.push(location.name)
    })
    setPositions(newPos)
    setLabel(newLabel)
  }, [eventLocations])

  return (
    <>
      <LocationMap height={props.height} positions={positions} mapZoom={props.mapZoom} label={label} />
    </>
  )
}

export default EventMap
